import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import ReactCodeInput from "react-code-input";
import classNames from "classnames";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { isJWTValid, extractAuthContextFromJWT } from "../../lib/jwt";
import FormInput from "../common/FormInput";
import Button from "../common/Button";
import Stepper from "../common/Stepper";
import _ from "../../i18n";

import {
  getClientCredential,
  acceptEmailInvitationGo,
  rejectEmailInvitationGo,
  emailAcceptInvitation,
  emailRejectInvitation,
  getStudentInfos,
  profileCheckMail,
  profileValidateMail,
  profileCheckPhone,
  saveSharedPremium,
  profileValidatePhone,
} from "../../api";
import { setAuthToken, setJwtToken } from "../../store";
import {
  validatePhone,
  formatPhone,
  validateEmail,
  cleanEmail,
} from "../../utils";

import LeftSide from "../Login/LeftSide";
import styles from "./Invitation.module.scss";

const Invitation = () => {
  const auth = useSelector((state) => state.auth);
  const lng = useSelector((state) => state.params.language);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [id, setId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [jwtToken, setJwttToken] = useState(null);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [roles, setRoles] = useState([]);
  const [fiduciaryId, setfiduciaryId] = useState(null);
  const [communityId, setCommunityId] = useState(null);
  const [fiduciaryName, setfiduciaryName] = useState("");
  const [fiduciaryMode, setFiduciaryMode] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [student, setStudent] = useState(null);
  const [step, setStep] = useState(1); // 4 steps
  const [redirectLink, setRedirentLink] = useState("/");
  const [showPersonalEmail, setShowPersonalEmail] = useState(false);
  const [personalEmail, setPersonalEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [emailCode, setEmailCode] = useState("");
  const [errorEmailCode, setErrorEmailCode] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneCode, setPhoneCode] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [showPhoneCode, setShowPhoneCode] = useState(false);
  const [errorPhoneCode, setErrorPhoneCode] = useState("");
  const [otherPhone, setOtherPhone] = useState(false);
  const decodeJWT = (token) => {
    try {
      const payload = token.split(".")[1];
      return JSON.parse(atob(payload));
    } catch (e) {
      return null;
    }
  };
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) return;

    setJwtToken(token);

    const decoded = decodeJWT(token);
    if (decoded) {
      setUserId(decoded.user_id);
      setEmail(decoded.email);
      setCommunityId(decoded.community_id);
      setfiduciaryId(decoded.org_id);
      setfiduciaryName(decoded.org_name);

      setRoles(decoded.existing_organizations);
    }
  }, []);
  useEffect(() => {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    console.log("vars =======", vars);
    let fidId = null,
      userId = null,
      jwtToken = null,
      fidType = null;
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");

      if (pair[0] === "user_id") {
        setId(decodeURIComponent(pair[1]));
      }
      if (pair[0] === "uid") {
        userId = decodeURIComponent(pair[1]);
        setUserId(userId);
      }
      if (pair[0] === "token") {
        jwtToken = decodeURIComponent(pair[1]);
        setJwttToken(jwtToken);
        setJwtToken(jwtToken);
      }
      if (pair[0] === "email") {
        setEmail(decodeURIComponent(pair[1]));
      }
      if (pair[0] === "fid") {
        fidId = decodeURIComponent(pair[1]);
        setfiduciaryId(decodeURIComponent(pair[1]));
      }
      if (pair[0] === "org_name" && pair[1].length > 0) {
        setfiduciaryName(decodeURIComponent(pair[1].replace(/\+/g, " ")));
      }
      // if (pair[0] === "community_id" && pair[1].length > 0) {
      //   setfiduciaryName(decodeURIComponent(pair[1].replace(/\+/g, " ")));
      // }
      if (pair[0] === "role_type") {
        setRole(decodeURIComponent(pair[1]));
      }
      if (pair[0] === "type") {
        fidType = decodeURIComponent(pair[1]);
        setFiduciaryMode(fidType);
      }
      if (pair[0] === "roles") {
        const jsonRoles = decodeURIComponent(pair[1]);
        if (jsonRoles) {
          setRoles(JSON.parse(jsonRoles));
        }
      }
    }
    let authC = extractAuthContextFromJWT(jwtToken);
    console.log("authC,,...", authC, auth, authC.jwtToken, jwtToken);
    if (!jwtToken || !isJWTValid(jwtToken)) {
      getClientCredential().then((resp) => {
        const helpResp = typeof resp === "string" ? JSON.parse(resp) : resp;
        const token = helpResp.token.access_token;
        dispatch(setAuthToken(token));

        if (fidType === "UNIVERSITY" && userId && fidId) {
          setIsSaving(true);
          getStudentInfos(token, userId, fidId)
            .then((resp) => {
              setStudent(resp.data.data);
              if (resp.data.data.userId) {
                setUserId(resp.data.data.userId);
              }
              if (resp.data.data.phones.length === 0) {
                setOtherPhone(true);
              } else {
                setPhone(resp.data.data.phones[0]);
              }

              if (resp.data.data.alreadyAccepted) {
                if (resp.data.data.hasValidPhone) {
                  // navigate("/");
                } else {
                  setStep(3);
                }
              }
            })
            .finally(() => setIsSaving(false));
        }
      });
    }
  }, []);

  const handleAccept = () => {
    console.log("authC,,... handleAccept jwtToken: ", jwtToken);
    if (jwtToken) {
      setIsSaving(true);
      acceptEmailInvitationGo(jwtToken)
        .then((resp) => {
          const { token, refresh_token, redirect } = resp;

          if (redirect) {
            navigate(
              `${redirect}?jwttoken=${token}&refresh_token=${refresh_token}&email=${email}&communnity_id=${communityId}&fiduciary_id=${fiduciaryId}`
            );
          } else {
            navigate("/");
          }
          // if (resp.data.data && resp.data.data.redirectLink) {
          // navigate(resp.data.data.redirectLink);
          // }
          // navigate("/");
        })
        .catch((e) => {
          if (
            e.response &&
            e.response.data &&
            e.response.data.errors &&
            e.response.data.errors.length > 0
          ) {
            toast.error(_(e.response.data.errors[0].message));
          } else {
            toast.error(_("error"));
          }
          // navigate("/");
        })
        .finally(() => setIsSaving(false));
    } else {
      toast.error(_("error"));
      navigate("/");
    }
  };

  const handleReject = () => {
    if (jwtToken) {
      setIsSaving(true);
      rejectEmailInvitationGo(jwtToken)
        .then((resp) => {
          toast.success(_("invitation_reject"));
          setTimeout(() => {
            navigate("/");
          }, 1000);
        })
        .catch((e) => {
          if (
            e.response &&
            e.response.data &&
            e.response.data.errors &&
            e.response.data.errors.length > 0
          ) {
            toast.error(_(e.response.data.errors[0].message));
          } else {
            toast.error(_("error"));
          }
        })
        .finally(() => setIsSaving(false));
    } else {
      toast.error(_("error"));
    }
  };

  const handleValidateStudent = async (newUserId) => {
    const idUser = newUserId ? newUserId : userId;
    emailAcceptInvitation(auth.token, idUser, id, email, fiduciaryId)
      .then(async (resp) => {
        if (resp.data.data && resp.data.data.redirectLink) {
          setRedirentLink(resp.data.data.redirectLink);
        }

        try {
          await saveSharedPremium({
            token: auth.token,
            users: [idUser],
            premiumSharedBy: 8650,
          });

          setStep(3);
          // if (resp.data.data && resp.data.data.redirectLink) {
          //   navigate(resp.data.data.redirectLink);
          // }
        } catch (e) {
          setStep(3);
          // if (resp.data.data && resp.data.data.redirectLink) {
          //   navigate(resp.data.data.redirectLink);
          // }
        }
      })
      .catch((e) => {
        if (
          e.response &&
          e.response.data &&
          e.response.data.errors &&
          e.response.data.errors.length > 0
        ) {
          toast.error(_(e.response.data.errors[0].message));
        } else {
          toast.error(_("error"));
        }
        navigate("/");
      })
      .finally(() => setIsSaving(false));
  };
  const sendEmailCode = () => {
    setIsSaving(true);
    profileCheckMail({
      token: auth.token,
      userId,
      email: personalEmail,
      language: lng,
    })
      .then((resp) => {
        // setStep(2);
        setShowPersonalEmail(false);
      })
      .catch((e) => {
        if (
          e.response &&
          e.response.data &&
          e.response.data.errors &&
          e.response.data.errors.error
        ) {
          toast.error(_(e.response.data.errors.error));
        } else {
          toast.error(_("error"));
        }
      })
      .finally(() => setIsSaving(false));
  };

  const sendPhoneCode = () => {
    setIsSaving(true);
    profileCheckPhone({
      token: auth.token,
      userId,
      phone,
      language: lng,
    })
      .then((resp) => {
        setShowPhoneCode(true);
      })
      .catch((e) => {
        if (
          e.response &&
          e.response.data &&
          e.response.data.errors &&
          e.response.data.errors.error
        ) {
          toast.error(_(e.response.data.errors.error));
        } else {
          toast.error(_("error"));
        }
      })
      .finally(() => setIsSaving(false));
  };

  const handleStudentAccept = () => {
    if (id || userId) {
      let isValidEmail = false;
      if (student.hasValidEmail) {
        isValidEmail = true;
      } else {
        if (student.personalEmails.includes(email)) {
          isValidEmail = true;
        }
      }
      if (isValidEmail) {
        // setStep(3);
        setIsSaving(true);
        handleValidateStudent();
      } else {
        // sendEmailCode();
        setShowPersonalEmail(true);
        setStep(2);
      }
    } else {
      toast.error(_("error"));
      navigate("/");
    }
  };

  const handleEmailCode = () => {
    if (emailCode.length < 6) {
      setErrorEmailCode("Veuillez entrer le code de vérification");
      return null;
    }

    setErrorEmailCode("");
    setIsSaving(true);
    profileValidateMail({
      token: auth.token,
      userId,
      email: personalEmail,
      key: emailCode,
    })
      .then((resp) => {
        if (resp.data.data.newUserId) {
          setUserId(resp.data.data.newUserId);
          handleValidateStudent(resp.data.data.newUserId);
        } else {
          handleValidateStudent();
        }
      })
      .catch((e) => {
        if (
          e.response &&
          e.response.data &&
          e.response.data.errors &&
          e.response.data.errors.error
        ) {
          toast.error(_(e.response.data.errors.error));
        } else {
          toast.error(_("error"));
        }
        setIsSaving(false);
      });
  };

  const handlePhoneKeyUp = (fieldValue, returnValue = false) => {
    let value = "";
    if (fieldValue.length === 0) {
      value = _("required_field");
    } else {
      const result = validatePhone(fieldValue);
      if (!result.valid) {
        value = _("validate_phone");
      }
    }
    setPhoneError(value);
    if (returnValue) {
      return value;
    }
  };

  const handlePhoneCode = () => {
    if (phoneCode.length < 6) {
      setErrorPhoneCode("Veuillez entrer le code de vérification");
      return null;
    }

    setErrorPhoneCode("");
    setIsSaving(true);
    profileValidatePhone({
      token: auth.token,
      userId,
      phone,
      key: phoneCode,
    })
      .then((resp) => {
        // setStep(3);
        navigate(redirectLink);
      })
      .catch((e) => {
        if (
          e.response &&
          e.response.data &&
          e.response.data.errors &&
          e.response.data.errors.error
        ) {
          toast.error(_(e.response.data.errors.error));
        } else {
          toast.error(_("error"));
        }
      })
      .finally(() => setIsSaving(false));
  };

  const handleBlurEmail = (e) => {
    const emailStr = cleanEmail(e.target.value);
    if (!validateEmail(emailStr)) {
      setEmailError(_("validate_email"));
    } else {
      setEmailError("");
    }
  };

  const handleValidateEmail = () => {
    const emailStr = cleanEmail(personalEmail);
    if (!validateEmail(emailStr)) {
      setEmailError(_("validate_email"));
      return null;
    }

    sendEmailCode();
  };

  const handleValidatePhone = () => {
    const error = handlePhoneKeyUp(phone, true);
    if (error.length > 0) {
      setOtherPhone(true);
      return null;
    }

    sendPhoneCode();
  };

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.leftSide}>
          <LeftSide />
        </div>
        <div className={styles.rightSide}>
          <div
            className={`${styles.content} ${
              fiduciaryMode === "UNIVERSITY" && styles.content_lg
            }`}
          >
            <h1 className={styles.title}>Invitation</h1>

            {fiduciaryMode === "UNIVERSITY" ? (
              <>
                <Stepper
                  steps={[
                    "Invitation",
                    "Validation de l'email",
                    "Validation du téléphone",
                    "Connexion",
                  ]}
                  currentStep={step}
                />
                {step === 1 ? (
                  <div style={{ textAlign: "justify" }}>
                    <p style={{ marginTop: "2rem" }}>
                      Vous êtes invité par{" "}
                      <b>
                        {fiduciaryId === 22149
                          ? "SS- Solvay Executive Master en gestion fiscale"
                          : fiduciaryName}
                      </b>{" "}
                      à rejoindre United Associates en tant{" "}
                      {role === "OFFICIAL" ? "qu'étudiant" : _(role)}.
                    </p>
                    <p style={{ margin: "10px 0" }}>
                      Cette plateforme technologique et confraternelle est
                      utilisée pour partager l'accès au programme de formation
                      oFFFcourse par votre université. Cet accès se dénomme
                      "Premium Partagé".
                    </p>
                    <p style={{ margin: "10px 0" }}>
                      "Premium Partagé" vous donne un libre accès aux
                      formations, sans toutefois vous délivrez d'attestation de
                      présence, un privilège réservé aux seuls "Premium".
                    </p>
                    <p>
                      N'hésitez pas à prendre contact avec notre équipe :
                      info@unitedassociates.be
                    </p>

                    <div className={styles.actions}>
                      <Button onClick={() => handleReject()} variant="danger">
                        Refuser
                      </Button>
                      <Button onClick={() => handleStudentAccept()}>
                        Accepter
                      </Button>
                    </div>
                  </div>
                ) : step === 2 ? (
                  <>
                    {showPersonalEmail ? (
                      <>
                        <div style={{ width: "60%" }}>
                          <label className={styles.labelTitle}>
                            Veuillez entrer votre email personnel:
                          </label>
                          <FormInput
                            name="email"
                            value={personalEmail}
                            label={_("email")}
                            error={emailError}
                            className="ttp-input-lg"
                            labelClassName="ttp-label-lg"
                            // autoComplete="off"
                            onChange={(e) => setPersonalEmail(e.target.value)}
                            onBlur={(e) => handleBlurEmail(e)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handleValidateEmail();
                              }
                            }}
                          />
                        </div>
                        <div className={styles.actions}>
                          <Button onClick={() => handleValidateEmail()}>
                            Valider
                          </Button>
                        </div>
                      </>
                    ) : (
                      <>
                        <label className={styles.labelTitle}>
                          {_("check_your_email")}
                        </label>
                        <label className="ttp-label ttp-label-lg">
                          Votre code
                        </label>
                        <div className={styles.codeBox}>
                          <ReactCodeInput
                            type="number"
                            fields={6}
                            value={emailCode}
                            onChange={(value) => setEmailCode(value)}
                            autoFocus={false}
                            className={styles.codeInput}
                            inputStyle={{
                              marginRight: "0.463rem",
                              width: "34px",
                              borderRadius: "4px",
                              fontSize: "14px",
                              height: "44px",
                              backgroundColor: "#F8F9FA",
                              border: "1px solid #B6BFC8",
                              textAlign: "center",
                            }}
                          />
                        </div>
                        {errorEmailCode && (
                          <span className={styles.codeError}>
                            {errorEmailCode}
                          </span>
                        )}

                        <div className={styles.actions}>
                          <Button onClick={() => handleEmailCode()}>
                            Valider
                          </Button>
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <div style={{ width: "60%" }}>
                      {!showPhoneCode ? (
                        <>
                          {student.phones?.length > 0 && (
                            <>
                              <label className={styles.labelTitle}>
                                Veuillez choisir votre numéro de téléphone
                                personnel pour validation, un code sera envoyé à
                                ce numéro:
                              </label>

                              {student.phones.map((phoneValue, i) => (
                                <div
                                  key={`phone${i}`}
                                  className={classNames(
                                    styles.card,
                                    phoneValue === phone ? styles.selected : ""
                                  )}
                                  onClick={() => {
                                    setOtherPhone(false);
                                    setPhone(phoneValue);
                                  }}
                                >
                                  <div className={styles.check}>
                                    {phoneValue === phone && (
                                      <i className="icon-ttp-check"></i>
                                    )}
                                  </div>
                                  <label>{formatPhone(phoneValue)}</label>
                                </div>
                              ))}
                              <div
                                className={classNames(
                                  styles.card,
                                  otherPhone ? styles.selected : ""
                                )}
                                onClick={() => {
                                  setOtherPhone(true);
                                  setPhone("");
                                }}
                              >
                                <div className={styles.check}>
                                  {otherPhone && (
                                    <i className="icon-ttp-check"></i>
                                  )}
                                </div>
                                <label>Autre</label>
                              </div>
                            </>
                          )}

                          {otherPhone && (
                            <>
                              <label className={styles.labelTitle}>
                                Veuillez entrer votre numéro de téléphone
                                personnel:
                              </label>
                              <div className={styles.phoneGroup}>
                                <PhoneInput
                                  defaultCountry="BE"
                                  placeholder={_("mobile_phone_number")}
                                  value={phone}
                                  onChange={(val) => {
                                    setPhone(val);
                                    if (!val) {
                                      setPhoneError(_("required_field"));
                                    } else if (!isValidPhoneNumber(val)) {
                                      setPhoneError(_("validate_phone"));
                                    } else {
                                      setPhoneError("");
                                    }
                                  }}
                                />
                                <span className={styles.errorSpan}>
                                  {phoneError}
                                </span>
                              </div>
                            </>
                          )}
                          <div className={styles.actions}>
                            <Button onClick={() => handleValidatePhone()}>
                              Continuer
                            </Button>
                          </div>
                        </>
                      ) : (
                        <>
                          <label className={styles.labelTitle}>
                            {_("check_your_phone")}
                          </label>
                          <label className="ttp-label ttp-label-lg">
                            Votre code
                          </label>
                          <div className={styles.codeBox}>
                            <ReactCodeInput
                              type="number"
                              fields={6}
                              value={phoneCode}
                              onChange={(value) => setPhoneCode(value)}
                              autoFocus={false}
                              className={styles.codeInput}
                              inputStyle={{
                                marginRight: "0.463rem",
                                width: "34px",
                                borderRadius: "4px",
                                fontSize: "14px",
                                height: "44px",
                                backgroundColor: "#F8F9FA",
                                border: "1px solid #B6BFC8",
                                textAlign: "center",
                              }}
                            />
                          </div>
                          {errorPhoneCode && (
                            <span className={styles.codeError}>
                              {errorPhoneCode}
                            </span>
                          )}

                          <div className={styles.actions}>
                            <Button
                              onClick={() => setShowPhoneCode(false)}
                              variant="default"
                            >
                              {_("back")}
                            </Button>
                            <Button onClick={() => handlePhoneCode()}>
                              Valider
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                <p>
                  Vous êtes invité à rejoindre l'équipe <b>{fiduciaryName}</b>{" "}
                  sur United Associates{" "}
                  {role && (
                    <>
                      en tant que <b>{_(role)}</b>
                    </>
                  )}
                </p>

                {roles?.length > 0 && (
                  <div>
                    <p className={styles.list_title}>
                      Vous avez déjà les roles suivants:
                    </p>
                    <ul className={styles.list}>
                      {roles.map((role, idx) => (
                        <li key={idx}>
                          {decodeURI(role.org_name).replace(/\+/g, " ")}:{" "}
                          {role.role === "LEGAL_REPRESENTATIVE"
                            ? _(role.role + "_" + role.typeStatus)
                            : _(role.role)}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <div className={styles.actions}>
                  <Button onClick={() => handleReject()} variant="danger">
                    Refuser
                  </Button>
                  <Button onClick={() => handleAccept()}>Accepter</Button>
                </div>
              </>
            )}

            {isSaving && <div className="lmask"></div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invitation;
